export default "__VITE_ASSET__BJZeFaFm__"